import { IUserPlayer, UpdatePlayer } from "@grassrootly/api";
import { useCallback, useEffect, useState } from "react";
import { EditProfileProps, IProfileForm, profileForm } from "./Profile.types";
import { FormBuilderType, useAlert, useAppDispatch } from "@grassrootly/rn-core";
import useBaseRequest from "../../api/BaseRequest";
import { authActions } from "../../api/auth/AuthReducer";
import { ImageResponse } from "../../components/image-picker";

export function useEditProfile({ player, onEditFinished }: EditProfileProps) {
  const [newImage, setNewImage] = useState<ImageResponse | null>(null);
  const [profileFormState, setProfileForm] = useState<FormBuilderType<IProfileForm> | null>(null);
  const dispacth = useAppDispatch();
  const { success } = useAlert();

  useEffect(() => {
    setProfileForm({ ...profileForm, name: { ...profileForm.name, defaultValue: player.name } });
  }, [player]);
  const { execute, loading: updating } = useBaseRequest(UpdatePlayer, {
    onCompleted: (data) => {
      if (!data) return;
      success({ message: "Player data updated successfully" });
      dispacth(authActions.setUser({ ...player, ...data }));
      onEditFinished();
    },
  });
  const onSubmitEdit = useCallback(
    (payload: IProfileForm) => {
      const frm = new FormData();
      frm.append("name", payload.name);
      if (newImage) {
        frm.append(
          "image",
          JSON.stringify({
            ...newImage,
            name: newImage.name || `profile_avatar.${newImage.contentType?.replace("image/", "")}`,
          })
        );
      }
      execute({ id: player.id, paylod: frm });
    },
    [player, newImage]
  );
  return {
    profileFormState,
    onSubmitEdit,
    onNewImagePicked: setNewImage,
    newImage,
    onUploadCancel: () => setNewImage(null),
    updating,
  };
}
